
import React from "react";
import { useAuth } from "@/contexts/auth-context";
import { useNavigate } from "react-router-dom";
import { DashboardLayout } from "@/components/dashboard/DashboardLayout";
import { useDashboard } from "@/hooks/use-dashboard";
import { UserSettings } from "@/components/dashboard/UserSettings";
import { Loader2 } from "lucide-react";

export default function SettingsPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const {
    activeTab,
    setActiveTab,
    walletData,
    loadingWallet,
  } = useDashboard();

  React.useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-purple-600" />
      </div>
    );
  }

  if (!user) return null;
  
  // Prepare the walletData for DashboardLayout
  const formattedWalletData = walletData ? {
    balance: walletData.balance,
    agentsPurchased: 0,
    lastPurchase: 'No purchases yet'
  } : {
    balance: 0,
    agentsPurchased: 0,
    lastPurchase: 'No purchases yet'
  };

  return (
    <DashboardLayout 
      user={user}
      isLoading={loading}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      walletData={formattedWalletData}
      loadingWallet={loadingWallet}
    >
      <div className="container mx-auto p-4 md:p-6">
        <UserSettings />
      </div>
    </DashboardLayout>
  );
}
